// 定义全局变量
const globalVariables = {
  $globalVideoType: window.$videoSelectType || 'mp4', // 默认视频类型，默认为mp4
  $isInternationalCourse: sessionStorage.getItem('isInternationalCourse') ? true : false, // 是否国际课程，默认为false
};

// 创建插件
const GlobalVariablePlugin = {
  install(Vue) {
    Object.keys(globalVariables).forEach(key => {
      Vue.prototype[key] = globalVariables[key];
    });
  }
};

export default GlobalVariablePlugin;



// WEBPACK FOOTER //
// ./src/utils/globalVariablePlugin.js